module.exports = __webpack_public_path__ + "img/callus_tel_icon.0e3ab8f7.png";